export enum ConnectionVariableKind {
  toReceive = 'to_receive',
  toSend = 'to_send',
}

export type ConnectionVariableModel = {
  id: number;
  name: string;
  createdAt: string;
  type: string;
  system: boolean;
  static?: boolean;
  header?: boolean;
  sentAs?: string;
  receivedAs?: string;
  value?: string | null;
  kind: ConnectionVariableKind;
};
